import { useSelector, useDispatch } from "react-redux";
import {
  selectReportDateValue,
  updateEndDate,
  updateStartDate,
} from "../../../App/State/Slices/ReportDateSlice";

/**
 * @description Sets up the Role Selection state used by both User Management and User Creation
 */
export function useReportDateState() {
  const dispatch = useDispatch();
  const reportDate = useSelector(selectReportDateValue);

  let startDate = reportDate.startDate;
  let endDate = reportDate.endDate;

  function setStartDate(value) {
    dispatch(updateStartDate(value));
  }

  function setEndDate(value) {
    dispatch(updateEndDate(value));
  }

  return {
    effects: {},
    getters: {
      startDate,
      endDate,
    },
    handlers: {},
    setters: {
      setStartDate,
      setEndDate,
    },
  };
}
